<label style="font-weight: 600;"  >{{richtext?.title}}:</label>
<app-template-editor
  [tempValue]="richtext?.value"
  [height]="'170px'"
  (onEditorKeyup)="showValue($event)">
</app-template-editor>
